import { tv } from 'tailwind-variants';

export const separatorStyles = tv({
  base: 'rounded-lg border-0 flex ',
  variants: {
    variant: {
      auth: 'bg-zinc-200 dark:bg-zinc-500',
      form: 'bg-zinc-200 dark:bg-zinc-500',
      dotted: 'border-l-2 border-dotted border-secondary',
    },
    orientation: {
      vertical: 'h-full w-px',
      horizontal: 'h-px w-full my-6',
    },
  },
  defaultVariants: {
    orientation: 'horizontal',
  },
});
